import { atom } from "recoil";

export const createStringAtom = (key: string, defaultVal: string) => {
  return atom<string>({
    key,
    default: defaultVal
  });
};

export const createBooleanAtom = (key: string, defaultVal: boolean) => {
  return atom<boolean>({
    key,
    default: defaultVal
  });
};

export const createArrayAtom = <T>(key: string, defaultVal: T[]) => {
  return atom<T[]>({
    key,
    default: defaultVal
  });
};

export const createNumberAtom = (key: string, defaultVal: number) => {
  return atom({
    key,
    default: defaultVal
  });
};
